import { apiService } from '@/api/apiService';
import { ApiResponseType } from '@/types/sharedTypes';
import { PublicRecipientRequestStateType } from '@/types/vendorVaultTypes';

export const openRecipientRequestApi = (token: string): Promise<ApiResponseType<PublicRecipientRequestStateType>> =>
  apiService.GET(`/recipient-requests/${token}/`);
